import React from 'react'
import PropTypes from 'prop-types'
import isNull from 'lodash/isNull'

import isFunction from 'lodash/isFunction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getFormCustomActions } from 'pmt-modules/form/config'
import { areFormDataLooselyEqual } from 'pmt-modules/form/utils'
import cloneDeep from 'lodash/cloneDeep'

import { initForm, updateForm, resetForm } from '../actions'

import { makeGetFormData, makeGetFormErrors, makeGetFormOptions } from '../selectors'

class FormContainer extends React.Component {
  constructor(props) {
    super(props)
    this.initialDefaultData = null
  }

  componentWillMount() {
    if (
      !isNull(this.props.defaultData) ||
      // if the defaultData from props is null
      // but the default data defined in the form creation (cf. createForm) is not null
      // we need to init the form with those data
      !isNull(this.props.formData)
    ) {
      const defaultData = {
        ...this.props.formData, // default data defined on the form creation
        ...this.props.defaultData, // given default data from props
      }
      this.props.initForm(this.props.formType, defaultData)
      this.initialDefaultData = cloneDeep(defaultData)
    }
  }

  componentDidUpdate(prevProps) {
    if (isNull(prevProps.defaultData) && !isNull(this.props.defaultData)) {
      const defaultData = {
        ...this.props.formData, // default data defined on the form creation
        ...this.props.defaultData, // given default data from props
      }
      this.props.initForm(this.props.formType, defaultData)
      this.initialDefaultData = cloneDeep(defaultData)
    }
  }

  handleChange = formData => {
    this.props.updateForm(this.props.formType, formData)
  }

  handleReset = () => {
    this.props.resetForm(this.props.formType, this.props.defaultData)
  }

  /**
   * Put the current data as initial data (no more diff)
   */
  reinitForm = () => {
    this.props.initForm(this.props.formType, this.props.formData)
    this.initialDefaultData = cloneDeep(this.props.formData)
  }

  render() {
    const {
      formData,
      formErrors,
      formOptions,
      WrappedComponent,
      children,
      ...otherProps
    } = this.props

    const propsToPass = {
      formData,
      formErrors,
      formOptions,
      formIsValid: formErrors.isValid,
      // TODO deprecated, use formIsValid
      isValid: formErrors.isValid,
      onChange: this.handleChange,
      onReset: this.handleReset,
      hasDiff: !areFormDataLooselyEqual(this.initialDefaultData, formData),
      reinitForm: this.reinitForm,
      ...otherProps,
    }

    // For debug only
    // keep commented
    // uncomment only if you need to debug the hasDiff logic
    /*
    if (propsToPass.hasDiff === true) {
      const diffs = findAllDifferences(this.initialDefaultData, formData)
      console.log('FormContainer: form ' + this.props.formType + ' has diff:', diffs)
    }
     */

    if (isFunction(children)) {
      return children(propsToPass)
    }

    return <WrappedComponent {...propsToPass} />
  }
}

FormContainer.defaultProps = {
  defaultData: null,
}

FormContainer.propTypes = {
  formType: PropTypes.string.isRequired,

  /**
   * Default data to use on form mounting
   */
  defaultData: PropTypes.object,
}

const makeMapStateToProps = () => {
  const getFormData = makeGetFormData()
  const getFormErrors = makeGetFormErrors()
  const getFormOptions = makeGetFormOptions()

  const mapStateToProps = (state, props) => {
    return {
      formData: getFormData(state, props),
      formErrors: getFormErrors(state, props),
      formOptions: getFormOptions(state, props),
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const formCustomActions = getFormCustomActions(ownProps.formType)

  return {
    initForm: bindActionCreators(initForm, dispatch),
    updateForm: bindActionCreators(updateForm, dispatch),
    resetForm: bindActionCreators(resetForm, dispatch),
    customActions: bindActionCreators(formCustomActions, dispatch),
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(FormContainer)
